// Shared Recharts tooltip styling for the dashboard (spec §7). No shadow.
export const DASH_TOOLTIP = {
  contentStyle: {
    background: 'var(--dash-card)',
    border: '1px solid var(--dash-border)',
    borderRadius: 6,
    fontSize: 11,
    padding: '4px 8px',
    color: 'var(--dash-foreground)',
  },
  labelStyle: { color: 'var(--dash-muted-foreground)', fontSize: 11 },
  itemStyle: { color: 'var(--dash-foreground)', fontSize: 11 },
};
